import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-admin-series',
  imports: [RouterModule],
  templateUrl: './admin-series.component.html',
  styles: ``
})
export class AdminSeriesComponent {

}
